export default __webpack_public_path__ + "static/media/54t.1d85a8cf.jpg";